import days from '@anm/constants/days';
import getDateMonthYear from '@anm/helpers/date/getDateMonthYear';

const getNextSundayDate = (timeMs: number) => {
  const [date, month, year] = getDateMonthYear(timeMs);

  const dd = new Date(`${year}-${`0${month + 1}`.slice(-2)}-${date}`);
  const day = dd.getDay();

  const calcDate = day ? days.length - day + date : date;

  const finalDate = new Date(year, month, calcDate);

  const [d, m, y] = getDateMonthYear(finalDate.getTime());

  const padDate = `0${d}`.slice(-2);
  const padMonth = `0${m + 1}`.slice(-2);

  return `${y}-${padMonth}-${padDate}`;
};

export default getNextSundayDate;
